import { apiClient } from "./client";

export interface RetailFrequencyResponse {
    period: {
        label: string;
        from: string;
        to: string;
        days: number;
    };
    store: string;
    storeOptions: string[];
    summary: {
        totalVisits: number;
        uniqueCustomers: number;
        avgVisitsPerCustomer: number;
        avgDaysBetweenVisits: number;
    };
    purchaseFrequency: Array<{
        visits: number;
        visitsLabel: string;
        customers: number;
        share: number;
        totalVisits: number;
        minVisits: number | null;
        maxVisits: number | null;
    }>;
    purchaseFrequencyMeta: {
        chartCustomers: number;
        chartVisits: number;
        excluded: {
            customers: number;
            visits: number;
            items: Array<{
                partnerId: number;
                customerName: string;
                visits: number;
                reason: "online" | "aggregate";
            }>;
        };
    };
    flowSettings: {
        intervalMinutes: number;
        hourFrom: number;
        hourTo: number;
    };
    hourlyFlow: Array<{
        slot: number;
        hour: number;
        label: string;
        visits: number;
        customers: number;
    }>;
    dailyFlow: Array<{
        date: string;
        visits: number;
        customers: number;
    }>;
    paymentMethods: Array<{
        paymentTypeId: number;
        paymentTypeName: string;
        payments: number;
        visits: number;
        share: number;
    }>;
    lastUpdatedAt: string;
}

export async function fetchRetailFrequencyReport(params: {
    period?: string;
    dateFrom?: string;
    dateTo?: string;
    store?: string;
    flowInterval?: number;
    flowHourFrom?: number;
    flowHourTo?: number;
}) {
    const { data } = await apiClient.get<RetailFrequencyResponse>("/reports/retail-frequency", {
        params: {
            period: params.period,
            date_from: params.dateFrom,
            date_to: params.dateTo,
            store: params.store,
            flow_interval: params.flowInterval,
            flow_hour_from: params.flowHourFrom,
            flow_hour_to: params.flowHourTo,
        },
    });

    return data;
}
